import { render, staticRenderFns } from "./SingleFile.vue?vue&type=template&id=fa834a86&"
import script from "./SingleFile.vue?vue&type=script&lang=js&"
export * from "./SingleFile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports